// Translations
import error from 'pages/error/translations/ru'
import login from 'pages/login/translations/ru'
import passwordChange from 'pages/password-change/translations/ru'
import register from 'pages/register/translations/ru'
import reset from 'pages/reset/translations/ru'
import termsOfService from 'pages/terms-of-service/translations/ru'
import twoFactorAuthentication from 'pages/two-factor-authentication/translations/ru'
import verification from 'pages/verification/translations/ru'

// Translation: Russian > Pages
const pages = Object.freeze({
	error,
	login,
	passwordChange,
	register,
	reset,
	termsOfService,
	twoFactorAuthentication,
	verification
})

// Export
export default pages
